import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { onlyPositiveNumber } from '@ubeya/shared/utils/form';
import { Container, Header3SemiBold, InputField as BaseInputField } from '@ubeya/shared-web/components';
import Header from './Header';

const Category = styled(Header3SemiBold)`
  background: ${({ theme }) => theme.colors.grey1};
  letter-spacing: 2.25px;
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 20px;
  padding: 4px 13px;
`;

const InputField = styled(BaseInputField)`
  width: 200px;
  margin-bottom: 15px;
`;

const PersonalSettings = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Header />
      <Category>{t('weeklyScheduleHours')}</Category>
      <InputField
        name="weeklyMinHours"
        title={`${t('employeeWeeklyMinHours')}`}
        onChange={onlyPositiveNumber}
        type="number"
        placeholder={`${t('default')}`}
      />
      <InputField
        name="weeklyMaxHours"
        title={`${t('employeeWeeklyMaxHours')}`}
        onChange={onlyPositiveNumber}
        type="number"
        placeholder={`${t('default')}`}
      />
    </Container>
  );
};

export default React.memo(PersonalSettings);
